import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

const BASE_URL = `/recommend-decks`;

const RecommendDecksService = {
    createMostPopular: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/createMostPopular`, data);
    },

    getMostPopular: (): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/getMostPopular`);
    },

    createTrendingDecks: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/createTrendingDecks`, data);
    },

    getTrendingDecks: (): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/getTrendingDecks`);
    },

    createSmartFlashcardPicks: (data: any): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/createSmartFlashcardPicks`, data);
    },

    getSmartFlashcardPicks: (): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/getSmartFlashcardPicks`);
    },
};

export default RecommendDecksService;